<template>
  <div>
    <div v-if="subscriptionPending" class="text-center">
      <AppLoader></AppLoader>
    </div>
    <template v-else-if="canAccessConsumption">
      <app-title-bar>
        <app-material-icon name="dashboard" />
        <h2>{{ $t('subscriptions.views.SubscriptionConsumption.title') }}</h2>
      </app-title-bar>
      <div class="d-flex flex-column row-gap-4 layout-spacing">
        <!-- Alert Storage Overcharge Enabled -->
        <template v-if="isDataroomStorageOverchargeEnabled">
          <Alert type="info" :dismissible="false">
            {{ $t('subscriptions.views.SubscriptionConsumption.packageOverchargeIsEnabled') }}
          </Alert>
        </template>

        <!-- Dataroom Storage -->
        <template v-if="hasSubscriptionEnvelopesPacks">
          <SubscriptionConsumptionPacks/>
        </template>
        <template v-if="hasDataroomStoragePlan">
          <SubscriptionConsumptionDataroomStorage/>
        </template>
      </div>
      
    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import Alert from '@/common/alerts/Alert.vue'
  import AppLoader from '@/common/AppLoader.vue'

  import SubscriptionConsumptionPacks from './SubscriptionConsumptionPacks.vue'
  import SubscriptionConsumptionDataroomStorage from './SubscriptionConsumptionDataroomStorage.vue'

  export default {
    name: 'SubscriptionConsumption',
    components: {
      AppLoader,
      Alert,
      SubscriptionConsumptionPacks,
      SubscriptionConsumptionDataroomStorage,
    },
    computed: {
      ...mapGetters('subscription', ['hasSubscriptionEnvelopesPacks', 'hasDataroomStoragePlan']),
      ...mapState('subscription', ['subscription', 'subscriptionPending', 'subscriptionDataroomStorage']),
      canAccessConsumption () {
        return this.hasDataroomStoragePlan
      },
      isDataroomStorageOverchargeEnabled () {
        return Number.parseFloat(this.subscriptionDataroomStorage?.limitGbOvercharge) > 0
      },
    },
  }
</script>
